<template>
  <div>
    <div class="title">退货标准及周期？</div>
    <div class="content-info">
      <p class="txt1">
        非生鲜类（米面粮油、调料干货、厨房用品等）支持7天无理由退货；
        <br />生鲜类（蔬菜水果、鲜肉蛋禽、海鲜水产、冷藏或冻货、面点等）支持18小时质量问题退货。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>
